import axios from "axios";
import React, { useEffect, useState } from "react";
const WhyChoose = () => {
  const [whyChooseCards, setWhyChooseCards] = useState([]);
  useEffect(() => {
    axios.get("JSON/whyChoose.json").then((response) => {
      setWhyChooseCards(response.data[0]);
    });
  }, []);
  return (
    <>
      <section className="eschool-why-choose">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-12">
              <div className="section-head section-left">
                <h3 className="section-head-title">
                  {whyChooseCards?.section_title}
                </h3>
                <p className="section-head-text">
                  {whyChooseCards?.section_detail}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {whyChooseCards?.features?.map((CardSingle, index) => (
              <div
                className="col-lg-4 col-xl-3 col-md-6 col-12"
                key={CardSingle.id}
              >
                <div
                  className={
                    index % 2 === 1
                      ? "why-choose-single add-margin"
                      : "why-choose-single"
                  }
                >
                  <div className="why-c-single-icon">
                    <img src={CardSingle.icon} alt="#" />
                    <span className="why-card-number">{index + 1}</span>
                  </div>
                  <div className="why-c-single-content">
                    <h4 className="why-c-single-cont-title">
                      {CardSingle.title}
                    </h4>
                    <p className="why-c-single-cont-text">{CardSingle.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChoose;
